/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Archived_SuccessInputs */



/**
* | output |
* | --- |
* | "Job archived successfully" |
*
* @param {Job_Archived_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const job_archived_success = /** @type {((inputs?: Job_Archived_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Archived_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tâche archivée avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Auftrag erfolgreich archiviert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lavoro archiviato con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Задание успешно завершено.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Trabajo archivado exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("职位已成功归档")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ジョブは正常にアーカイブされました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नौकरी सफलतापूर्वक संग्रहीत हो गई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tarefa arquivada com sucesso")
	return /** @type {LocalizedString} */ ("Job archived successfully")
});